var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 42 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21, 23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 66.666664,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(0.0674964 0 0 -0.0676365 0 0)",
    d: "M266.667 200C266.667 200 239.477 200 233.337 200C142.27 200 62.9033 235.505 -0.00335693 300C-62.9067 235.507 -142.267 200 -233.33 200C-239.47 200 -266.664 200 -266.664 200C-266.664 200 -266.667 133.333 -266.667 94.463C-266.667 -95.32 -153.353 -254.787 0 -300C153.353 -254.787 266.667 -95.32 266.667 94.463C266.667 133.333 266.667 200 266.667 200Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "matrix(0.0305699 0 0 -0.0306333 5.313 -0.121)",
    d: "M-34.375 21.1L17.975 21.1C25 21.1 30.475 14.85 30.475 7.82498L30.475 -267.175C30.475 -274.2 25 -279.675 17.975 -279.675L-387.5 -279.675C-394.525 -279.675 -400 -274.2 -400 -267.175L-400 7.82498C-400 14.85 -394.525 21.1 -387.5 21.1L-336.725 21.1L-336.725 149.225C-336.725 221.1 -290.625 280.475 -219.525 280.475L-152.325 280.475C-80.45 280.475 -34.35 221.1 -34.35 149.225L-34.35 21.1L-34.375 21.1ZM-270.3 21.1L-99.975 21.1L-99.975 142.975C-99.975 182.825 -132.8 216.425 -173.425 216.425L-197.65 216.425C-237.5 216.425 -270.3 182.825 -270.3 142.975L-270.3 21.1ZM-221.1 -200L-148.45 -200L-166.425 -121.1C-153.925 -114.85 -145.325 -101.575 -145.325 -86.725C-145.325 -64.075 -163.3 -46.875 -185.175 -46.875C-207.05 -46.875 -224.25 -64.075 -224.25 -86.725C-224.25 -101.575 -215.65 -114.85 -203.15 -121.1L-221.1 -200Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.9ead7ba09aebd4de7e1da6137cf0c66b.svg";
export { ForwardRef as ReactComponent };